import React, {Component} from 'react';

class Events extends Component {

    componentDidMount(){
        
        // let the transactions be mapped first
        // setTimeout(() => {
        //     let transType = document.querySelectorAll('.transType')
        //     let debit = '<i class="fas fa-arrow-circle-up"></i>'
        //     let credit = '<i class="fas fa-arrow-circle-down"></i>'

        //     for (let i = 0; i < transType.length; i++) {
        //         if (transType[i].innerText === 'Debit') {
        //             transType[i].className += " debit"
        //             transType[i].innerHTML = debit
        //         }else if (transType[i].innerText === 'Credit') {
        //             transType[i].className += " credit"
        //             transType[i].innerHTML = credit
        //         }
        //     }
        // }, 1000)
    }

    render() {
        return(
            <section className="eventlog">
                <article className="events">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Event</th>
                                <th scope="col">IP Address</th>
                                <th scope="col">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            { this.props.systemEvents.length <= 0 ? <tr><td colSpan="5">No events yet</td></tr> : this.props.systemEvents.map((row, index) => (
                                <tr key={index}>
                                    <td dangerouslySetInnerHTML={{__html: index+1}}></td>
                                    <td dangerouslySetInnerHTML={{__html: row.event}}></td>
                                    <td dangerouslySetInnerHTML={{__html: row.ip}}></td>
                                    <td dangerouslySetInnerHTML={{__html: row.time}}></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </article>
            </section>
        )
    }
}

export default Events;